import React, { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  Avatar,
  Box,
  ButtonBase,
  Hidden,
  makeStyles,
  Menu,
  MenuItem,
  Typography,
} from '@material-ui/core';
import * as images from 'images';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  avatar: { height: 48, width: 48, marginRight: theme.spacing(1) },
  popover: { width: 220 },
}));

function Account({ user }) {
  // Hooks
  const classes = useStyles();
  const ref = useRef(null);

  // Constants
  const items = [
    { key: 'account', label: 'Minha Conta', to: '/accounts' },
    { key: 'profile', label: 'Perfil', to: '/accounts/profile' },
    { key: 'password', label: 'Alterar senha', to: '/accounts/change-password' },
    { key: 'logout', label: 'Sair', to: '/logout' },
  ];

  // States
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        component={ButtonBase}
        onClick={() => setOpen(true)}
        ref={ref}>
        <Avatar
          alt={user.firstName}
          className={classes.avatar}
          src={user.picture || images.facesOtherFace}
        />
        <Hidden smDown>
          <Typography variant="h6" color="inherit">
            {`${user.firstName} ${user.lastName}`}
          </Typography>
        </Hidden>
      </Box>
      <Menu
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={open}>
        {items.map(item => (
          <MenuItem
            key={item.key}
            component={item.to ? RouterLink : 'a'}
            to={item.to}
            onClick={() => setOpen(false)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

Account.propTypes = {
  user: PropTypes.object,
};

export default Account;
